import { UnifiedPayApi } from '@/api/payment'
import wxshare from "@/utils/wxshare"

export function payment(self, 
    order_id, 
    style, 
    amount,
    body, 
    backurl){
    wxshare.getJSSDK()
    var that = self
    // orderid = data['order'] # 单据ID
    // style = data.get('style',None) # 支付类型
    // amount = data.get('amount', 0) # 支付金额
    // body = data.get('body','商场支付') # 传入支付

    const paymentdata = {
        "order": order_id,
        'style': style,
        'amount': amount,
        'body': body
    }
    that.axios.post(UnifiedPayApi, paymentdata).then((ret) => {
        window.wx.ready(function(){
            window.wx.chooseWXPay({
                timestamp: ret.timeStamp, 
                // 支付签名随机串，不长于 32 位
                nonceStr: ret.nonceStr, 
                package: ret.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: ret.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: ret.paySign, // 支付签名
            success: function(res) {
                console.log(res)
                console.log('支付成功')
                that.$router.push(backurl)
            },
            fail: function(res) {
                console.log(res)
                console.log('支付失败')
            },
            complete: function(res) {
                console.log(res, 'complete')
            }
            })
        })
    })
}